import { Grid, TextField, Typography } from '@mui/material';
import React from 'react';
import { CourtSearch } from '../../../generic/CourtSearch';
import { ILegalTransactionRelationshipRealEstate } from '../../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationshipRealEstate/ILegalTransactionRelationshipRealEstate';

interface IProps {
  formValues: ILegalTransactionRelationshipRealEstate;
  setFormValues: React.Dispatch<
    React.SetStateAction<ILegalTransactionRelationshipRealEstate>
  >;
}

export const RealEstateLandRegister: React.FC<IProps> = ({
  formValues,
  setFormValues,
}) => (
  <>
    <Typography variant='h5' sx={{ mt: 2, mb: 2 }}>
      Grundbuchinformationen
    </Typography>
    <Typography variant='body1' mb={2}>
      Falls Ihnen die Grundbuchinformationen bereits vorliegen, tragen Sie diese
      gerne ein. Andernfalls können diese Informationen zu einem späteren
      Zeitpunkt erfasst werden.
    </Typography>
    <Grid container spacing={2}>
      <Grid item sm={12}>
        <CourtSearch
          courtId={formValues.idCourt}
          setCourt={newCourt => {
            setFormValues(x => ({
              ...x,
              idCourt: newCourt?.idCourt ?? null,
            }));
          }}
        />
      </Grid>
      <Grid item sm={8}>
        <TextField
          label='Grundbuch'
          size='small'
          fullWidth
          value={formValues.LandRegister}
          onChange={({ target }: React.ChangeEvent<HTMLInputElement>) =>
            setFormValues(x => ({
              ...x,
              LandRegister: target.value,
            }))
          }
        />
      </Grid>
      <Grid item sm={4}>
        <TextField
          label='Blatt'
          size='small'
          fullWidth
          value={formValues.SheetLandRegister}
          onChange={({ target }: React.ChangeEvent<HTMLInputElement>) =>
            setFormValues(x => ({
              ...x,
              SheetLandRegister: target.value,
            }))
          }
        />
      </Grid>
      <Grid item sm={6}>
        <TextField
          label='Flurstück'
          size='small'
          fullWidth
          value={formValues.LandParcel}
          onChange={({ target }: React.ChangeEvent<HTMLInputElement>) =>
            setFormValues(x => ({
              ...x,
              LandParcel: target.value,
            }))
          }
        />
      </Grid>
      <Grid item sm={6}>
        <TextField
          label='Flur'
          size='small'
          fullWidth
          value={formValues.Parcel}
          onChange={({ target }: React.ChangeEvent<HTMLInputElement>) =>
            setFormValues(x => ({
              ...x,
              Parcel: target.value,
            }))
          }
        />
      </Grid>
    </Grid>
  </>
);
